/**
 * @prettier
 */

import { Login } from "./Login";

export default Login;
